export default (...params) => useHead(...params)